// TODO: für simon. typescript wooohooo damit pathParams auch wirklich ein object ist
// und erkennt welche Eigenschaften vorhanden sein sollen.
//
import { logger } from '@app/utils/logger';
import { isEmpty as _isEmpty } from 'lodash-es';

export function buildPathByPayload(urlTemplate: string, pathParams?: object, searchParams?: URLSearchParams): URL {
  if (pathParams instanceof URLSearchParams) {
    throw new Error('buildPathByPayload: Expected pathParams to be an object, but got URLSearchParams');
  }

  if (!urlTemplate.startsWith('/')) {
    console.error(`URL template must start with '/'. You passed ${urlTemplate}`);
    throw new Error(`URL template must start with '/'. You passed ${urlTemplate}`);
  }

  let currentURL = urlTemplate;

  if (pathParams) {
    Object.entries(pathParams).forEach(([key, value]) => {
      if (_isEmpty(value)) {
        logger.error({
          msg: `Path param :${key} is required to process ${urlTemplate}. Got ${JSON.stringify(value)} instead.`,
        });

        throw new Error(
          `Path param :${key} is required to process ${urlTemplate}. Got ${JSON.stringify(value)} instead.`
        );
      }
      currentURL = currentURL.replaceAll(`:${key}`, value.toString());
    });
  }

  const matches = currentURL.match(new RegExp(/(?<key>:[a-z_]+)/g));

  if (matches) {
    throw new Error(`Path param ${matches.join(', ')} is required`);
  }

  const url = new URL(`${window.location.origin}${currentURL}`);

  if (searchParams?.size) {
    Array.from(searchParams.entries()).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });

    searchParams = new URLSearchParams(searchParams.toString());
  }

  // console.group('buildPathByPayload', urlTemplate);
  // console.log('searchParams', searchParams ? JSON.stringify(qs.parse(searchParams.toString()), null, 4) : '---');
  // console.log('URL', url.toString());
  // console.groupEnd();

  return url;
}
